import React, { useState, useEffect } from 'react';
import './ImageSlideshow.css';
import image1 from '../assets/store1.JPG';
import image2 from '../assets/store2.JPG';
import image3 from '../assets/store3.JPG';
import image4 from '../assets/store4.JPG';
import image5 from '../assets/store5.JPG';

const ImageSlideshow = () => {
  const [currentImage, setCurrentImage] = useState(0);
  const images = [image1, image2, image3, image4, image5];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % images.length);
    }, 5000); // Change image every 5 seconds

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="slideshow-container">
      {images.map((image, index) => (
        <div
          key={index}
          className={`slide ${index === currentImage ? 'active' : ''}`}
        >
          <img src={image} alt={`Slide ${index + 1}`} />
        </div>
      ))}
      <div className="slideshow-dots">
        {images.map((_, index) => (
          <button
            key={index}
            className={`dot ${index === currentImage ? 'active' : ''}`}
            onClick={() => setCurrentImage(index)}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default ImageSlideshow;
